import glamorous from 'glamorous';
import BASE from './style';

export default glamorous.a(BASE);
